<template>
    <button
        :data-component="$options.name"
        type="button"
        aria-label="Add item"
        class="relative flex items-center cursor-pointer z-content-linkarea"
        @click="onClickLikeButton"
    >
        <component
            :is="'MsBookmarkFilled'"
            v-if="isVerticalDesign"
            class="w-24 h-24 m-10 transition-transform transform origin-center scale-100 hover:scale-110"
            :class="[
                liked && hasBeenClicked ? 'animate-scale-up' : 'animate-scale-down',
                liked
                    ? 'text-color-alert-negative-100'
                    : 'stroke-[1.5px] stroke-white text-color-neutral-black text-opacity-20',
            ]"
        />
        <component
            :is="liked ? 'MsBookmarkFilled' : 'MsBookmark'"
            v-else
            class="w-24 h-24 m-10 transition-transform transform origin-center scale-100 hover:scale-110"
            :class="[
                liked && hasBeenClicked ? 'animate-scale-up' : 'animate-scale-down',
                { 'text-color-alert-negative-100': liked },
            ]"
        />
    </button>
</template>
<script lang="ts" src="./MsLikeButton.ts" />

<style scoped lang="scss">
@keyframes scale-up {
    50% {
        transform: scale(1.25);
    }
}

@keyframes scale-down {
    20% {
        transform: scale(1);
    }
}

.animate-scale-up {
    animation: scale-up 0.25s cubic-bezier(0.77, -0.19, 0.33, 1.12);
}

.animate-scale-down {
    animation: scale-down 0.25s cubic-bezier(0.77, -0.19, 0.33, 1.12);
}
</style>
